import React, {useEffect, useState} from 'react';
import {Card, message, Button, Flex, Divider} from 'antd';
import {CloudUploadOutlined, SaveFilled} from "@ant-design/icons";
import * as xlsx from "xlsx";
import {IEnum, IClientError} from "./user-interfaces";
import {Gender, Type_Time} from "../../constant/constant";
import '../../styles/component/import-employees.scss'
import PreviewEmployees from "./import-employees/preview-import-employees";
import resources from "../../resources";
import {formatToISODateOnly} from "../../utility/utility";
import server from "../../server";

const EmployeeBatchUpload = () => {
    const [bulkEmployeeData, setBulkEmployeeData] = useState<any[]>([]);
    const [importedEmployeesRowData, setImportedEmployeesRowData] = useState<any>([]);
    const [errors, setErrors] = useState<IClientError[]>([]);
    const tempResource = resources.usersImport;
    const [designation, setDesignation] = useState<IEnum[]>([]);
    const [qualification, setQualification] = useState<IEnum[]>([]);

    useEffect(() => {
        fetchEnums()
    }, []);

    const fetchEnums = async () => {
        const allQualificationsData = await server.settings.qualification.list();
        const allDesignationsData = await server.settings.designation.list();

        const tempQualificationsData = allQualificationsData.map((qualification: any) => {
            return ({
                id: qualification.id,
                code: qualification.code
            })
        });

        const tempDesignationsData = allDesignationsData.map((designation: any) => {
            return ({
                id: designation.id,
                code: designation.code
            })
        })

        setQualification(tempQualificationsData);
        setDesignation(tempDesignationsData);
    }

    const verifyEnum = (key: string, rowData: any, errorObj: IClientError, Enum: any) => {
        let matchWithEnum;
        if (Array.isArray(Enum)) {
            matchWithEnum = Enum.find((tempEnum: IEnum) =>
                tempEnum.code.includes(rowData[key])
            );
            if (!matchWithEnum) {
                new Error(`${key} must be a valid ENUM!`);
            }
        } else {
            matchWithEnum = Object.keys(Enum).includes(rowData[key]);
        }
        if (!matchWithEnum) {
            const tempError = new Error(`${key} must be a valid ENUM!`);
            errorObj.errors.push(tempError);
        }
    }

    const checkRequiredFieldsAvailable = (rowData: any, index: number, tempErrors: IClientError, allEmployees: any) => {
        // accept one row at a time
        const rowKeys = Object.keys(rowData)
        tempResource.requiredFields.forEach((key: any) => {
            if (!rowKeys.includes(key)) {
                const tempNewError: Error = new Error(`Required Field ${key} is not available.`)
                tempErrors.errors.push(tempNewError)
            } else {
                // todo find the way to show in array
                switch (key) {
                    case "name_lastName": {
                        // fully string not number values
                        let isStr = /^[A-Za-z]+$/.test(rowData[key])
                        if (!isStr) {
                            const tempError = new Error(`${key} must be characters not include number or special character.`);
                            tempErrors.errors.push(tempError);
                        }
                        break;
                    }
                    case "contact": {
                        let isnum = /^[0-9+]+$/.test(rowData[key])
                        if (!isnum) {
                            const tempError = new Error(`${key} must be a number not include character.`);
                            tempErrors.errors.push(tempError);
                        }
                        break;
                    }
                    case "officialEmail": {
                        let isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(rowData[key]);
                        if (!isEmail) {
                            const tempError = new Error(`${key} must be a valid email address.`);
                            tempErrors.errors.push(tempError);
                        }
                        break;
                    }
                    case "gender": {
                        verifyEnum(key, rowData, tempErrors, Gender)
                        break
                    }
                    case "qualification":
                        verifyEnum(key, rowData, tempErrors, qualification)
                        //enum
                        break
                    case "joiningDate":
                        // not after today
                        break
                    case "designation": {
                        verifyEnum(key, rowData, tempErrors, designation);
                        break;
                    }
                    case "dateOfBirth": {
                        const tempDate = new Date(rowData[key]);
                        const month = tempDate.getMonth()
                        const year = tempDate.getFullYear();
                        const day = tempDate.getDate()
                        // Ensure the year is properly adjusted by adding 18 years, and the month index is correct
                        const completeEighteenDate = new Date(year + 18, month - 1, day);
                        // Get the current date and check if the person is older than 18
                        const difference = new Date().getTime() - completeEighteenDate.getTime();
                        // Check if the person is less than 18 years old
                        if (difference <= 0) {
                            const tempError = new Error(`Employee age should be greater than 18.`);
                            tempErrors.errors.push(tempError);
                        }
                        break;
                    }
                    case "type": {
                        verifyEnum(key, rowData, tempErrors, Type_Time)
                        break
                    }
                    case "employeeCode": {
                        let isAlphanumeric = /^[A-Za-z0-9]+$/.test(rowData[key]);
                        if (!isAlphanumeric) {
                            const tempError = new Error(`Employee code must be alphanumeric, containing only letters and numbers!.`);
                            tempErrors.errors.push(tempError);
                        }
                        break;
                    }
                    // case "permanentAddress_line1":
                    // case "permanentAddress_line2":
                    // case "presentAddress_line1":
                    case "presentAddress_line2": {
                        //check is string with alpha numeric character
                        let isAlphanumericWithComma = /^[A-Za-z0-9,// .-]+$/.test(rowData[key]);
                        // let isAlphanumericWithComma = true
                        if (!isAlphanumericWithComma) {
                            const tempError = new Error(`Line1/Line2 address must be alphanumeric, containing only letters and numbers!.`);
                            tempErrors.errors.push(tempError);
                        }
                        break;  // Assuming you need to exit after one validation check.
                    }
                    // case "permanentAddress_state":
                    // case "permanentAddress_city":
                    // case "presentAddress_state":
                    case "presentAddress_city": {
                        // fully string not number values
                        let isStr = /^[A-Za-z ]+$/.test(rowData[key])
                        if (!isStr) {
                            const tempError = new Error(`${key} must be characters not include number or special character!.`);
                            tempErrors.errors.push(tempError);
                        }
                        break
                    }
                    // case "permanentAddress_zipCode":
                    case "presentAddress_zipCode": {
                        //same as mobile number
                        let isNum = /^\d+$/.test(rowData[key])
                        if (!isNum) {
                            const tempError = new Error(`${key} must be a number not include character!.`);
                            tempErrors.errors.push(tempError);
                        }
                        break
                    }
                }
            }
        })
        tempResource.uniqueFields.forEach((key: string) => {
            switch (key) {
                case "contact": {
                    //duplicate error
                    const tempError = checkDuplicate(allEmployees, key, tempErrors.line, rowData[key])
                    if (tempError)
                        tempErrors.errors.push(tempError)
                    break;
                }
                case "email": {
                    const tempError = checkDuplicate(allEmployees, key, tempErrors.line, rowData[key])
                    if (tempError)
                        tempErrors.errors.push(tempError)
                    break;
                }
                case "officialEmail": {
                    const tempError = checkDuplicate(allEmployees, key, tempErrors.line, rowData[key])
                    if (tempError)
                        tempErrors.errors.push(tempError)
                    break;
                }
                case "familyDetails_mobileNumber": {
                    const tempError = checkDuplicate(allEmployees, key, tempErrors.line, rowData[key])
                    if (tempError)
                        tempErrors.errors.push(tempError)
                    break
                }
                case "bankDetail_accountNumber": {
                    const tempError = checkDuplicate(allEmployees, key, tempErrors.line, rowData[key])
                    if (tempError)
                        tempErrors.errors.push(tempError)
                    break;
                }
                case "employeeCode": {
                    const tempError = checkDuplicate(allEmployees, key, tempErrors.line, rowData[key])
                    if (tempError)
                        tempErrors.errors.push(tempError)
                    break;
                }
            }
        })
    }

    const checkDuplicate = (allEmployees: any, key: string, errorLineNo: number, value: string | number | object) => {
        const matchLines: number[] = []
        const fieldCountInObjects = allEmployees.filter((employee: any, index: number) => {
            const anotherPossibleKey = key.split("_")
            const tempEmployee = {
                ...employee,
                ...employee.name,
                ...employee.bankDetail,
                ...employee.familyDetails,
                ...employee.experiences,
                ...employee.permanentAddress,
                ...employee.presentAddress
            }
            if (value && (employee[key] === value || tempEmployee[anotherPossibleKey[anotherPossibleKey.length - 1]] === value)) {
                matchLines.push(index + 1)
                return true;
            }
            return false;
        });
        const index = matchLines.indexOf(errorLineNo) //checking line because remove from same line in and show another all in which available error
        matchLines.splice(index, 1);
        if (fieldCountInObjects.length > 1) {
            const tempError = new Error(`${key} same in another record! - ${matchLines.join(",")}`);
            return (tempError);
        }
    }

    async function handleOkImportFile() {
        const payload = bulkEmployeeData.map((employee) => (
            {
                ...employee,
                contact: String(employee?.contact),
                permanentAddress: {
                    ...employee.permanentAddress,
                    zipCode: String(employee.permanentAddress.zipCode)
                },
                presentAddress: {
                    ...employee.presentAddress,
                    zipCode: String(employee.presentAddress.zipCode)
                },
                ...(employee?.experiences?.employerName && {
                    experiences: [{
                        ...employee.experiences,
                        skills: String(employee?.experiences?.skills ?? "").split(",") ?? []
                    }],
                }),
                ...(employee?.familyDetails?.name && {familyDetails: [employee?.familyDetails]}),
                ...(employee?.bankDetail?.accountNumber && {
                    bankDetail: {
                        ...employee.bankDetail,
                        accountNumber: String(employee?.bankDetail?.accountNumber)
                    }
                }),
            })
        )
        try {
            await server.employee.admin.importUsersWithEmployee(payload);
            // window.location.href = "https://localhost:3000/user/list"
            // navigate('user/list')
            const currentUrl = window.location.href
            const newTempUrl = currentUrl.split("user/")
            const newUrl = newTempUrl[0] + "user/list"
            window.location.href = newUrl;
            // navigate(newUrl)
            // addInExisting()
            message.success("File Read Successfully!")
        } catch (error: any) {
            const errResponse = error.response.data.subErrors ?? [];
            if (errResponse.length > 0) {
                const errorResponse: IClientError[] = errResponse.map((customError: any) => {
                    const tempErrorObjectNumber: string = customError.object.toString()
                    const line: number = parseInt(tempErrorObjectNumber.charAt(tempErrorObjectNumber.length - 2));
                    const tempErrorsMessages: Error[] = customError.errors.map((subError: any) => (new Error(subError.message)))
                    return {
                        line: line + 1,
                        errors: tempErrorsMessages
                    }
                })
                setErrors(errorResponse);
            }
        }

    }

    const getKey = (tempKey: string) => {
        tempKey = tempKey.toLocaleLowerCase().trim();
        const tempPayloadKeys = tempResource.payloadKeys as any
        const newKey: string = tempPayloadKeys[tempKey]; //todo remove trim if use another location
        return newKey;
    };

    function getEnumId(type: string, value: string) {
        switch (type) {
            case "designation":
                return designation.find(
                    (tempDesignation: any) => tempDesignation.code === value
                );
            case "qualification":
                return qualification.find(
                    (tempQualification: any) => tempQualification.code === value
                );
        }
    }

    const formatData = (row: any) => {
        for (const element in row) {
            const underScoreVariableParts = element.split("_");

            if (underScoreVariableParts.length === 2) {
                const payloadField: any = underScoreVariableParts[0];
                const subPayloadField: any = underScoreVariableParts[1];
                if (row[payloadField]) {
                    row[payloadField] = {
                        ...row[payloadField],
                        [subPayloadField]: row[element],
                    };
                } else {
                    row[payloadField] = {
                        [subPayloadField]: row[element],
                    };
                }
                delete row[element];
            } else if (underScoreVariableParts.length === 3) {
                const payloadField: any = underScoreVariableParts[0];
                const subPayloadField: any = underScoreVariableParts[1];
                const subPayloadChild: any = underScoreVariableParts[2];
                if (row[payloadField][subPayloadField]) {
                    row[payloadField][subPayloadField] = {
                        ...row[payloadField][subPayloadField],
                        [subPayloadChild]: row[element],
                    };
                    delete row[element];
                } else {
                    row[payloadField][subPayloadField] = {
                        [subPayloadChild]: row[element],
                    };
                }
                delete row[element];
            } else {
                if (element === "designation" || element === "qualification") {
                    row[element] = {
                        ...getEnumId(element, row[element]),
                    };
                }
                if (element === "experiences" || element === "familyDetails") {
                    row[element] = [row[element]]
                }
            }
        }
    };

    const removeWhiteSpace = (tempVal: any) => {
        const tempType: string = typeof tempVal;
        // Ensure tempVal is a string and trim whitespace
        let tempStringVal: string | number = String(tempVal).trim();

        switch (tempType) {
            case "number": {
                const tempTrimVal = parseInt(tempStringVal);
                if (isNaN(tempTrimVal)) return NaN;  // Return NaN if the number is invalid
                return tempTrimVal;
            }
            case "boolean": {
                return tempVal;  // Return the trimmed boolean
            }

            case "object": {
                if (tempVal === null) {
                    return null; // Handle null case
                }

                // Handle Date object
                if (tempVal instanceof Date) {
                    tempVal.setDate(tempVal.getDate() + 1)
                    return tempVal; // Return the Date object itself
                }

                if (typeof tempVal === "string") {
                    const newDate = new Date(tempVal)
                    newDate.setDate(newDate.getDate() + 1)
                    // const newDate = new Date(dateArr[2], dateArr[0] - 1, dateArr[1]); // Month is zero-based
                    return newDate;
                }
                // If it's an object but not a date, return the object
                return tempVal;
            }

            case "string":
            case "String": {
                return tempStringVal;  // Return the trimmed string
            }

            default:
                return null;  // Handle unexpected types
        }
    };

    const readUploadFile = (e: any) => {
        e.preventDefault();
        // Check if files are selected
        if (e.target.files && e.target.files[0]) {
            // const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = e.target?.result;
                let json: any = []
                if (data) {
                    try {
                        const workbook = xlsx.read(data, {type: "array", cellDates: true});
                        const sheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[sheetName];
                        json = xlsx.utils.sheet_to_json(worksheet);
                    } catch (error) {
                        console.error("Error reading Excel file inside file read and cleanup data", error);
                    }
                    const newAllEmployees = json.map((employee: any) => {
                        let newPayloadSample: any = {};
                        for (let tempKey in employee) {
                            const key = getKey(tempKey); // call function to get valid keys one by one because in excel keys not in valid(camelCase)
                            if (key) {
                                newPayloadSample[key] = removeWhiteSpace(employee[tempKey]);
                            }
                        }
                        return newPayloadSample;
                    });
                    const rowDataShowInTable = window.structuredClone(newAllEmployees)
                    // set for showing all fields comes from excel file
                    const previewEmployeesTableData = rowDataShowInTable.map((row: any) => (
                        {
                            ...row,
                            dateOfBirth: formatToISODateOnly(row.dateOfBirth),
                            joiningDate: formatToISODateOnly(row.joiningDate),
                            experiences_duration_startDate: formatToISODateOnly(row.experiences_duration_startDate),
                            experiences_duration_endDate: formatToISODateOnly(row.experiences_duration_endDate)
                        }))
                    // console.log("previewEmployeesTableData: ", previewEmployeesTableData);
                    setImportedEmployeesRowData(previewEmployeesTableData);
                    // check all required field is available in data
                    let tempErrors: IClientError[] = []
                    const transformedData: any = newAllEmployees.map((row: any, index: number) => {
                        const tempError: IClientError = {
                            line: index + 1,
                            errors: []
                        }
                        checkRequiredFieldsAvailable(row, index, tempError, newAllEmployees)
                        if (tempError.errors.length >= 0) {
                            tempErrors.push({...tempError});
                        }
                        formatData(row);
                        return {
                            ...row,
                        };
                    });
                    setErrors([...errors, ...tempErrors])
                    setBulkEmployeeData(transformedData);
                }
            };
            reader.readAsArrayBuffer(e.target.files[0]);
            reader.onerror = (error) => {
                console.error("File could not be read!", error);
            };
        }
    };

    const isAnyError = () => {
        const errorStatus = errors.filter((error: IClientError) => (error.errors.length > 0))
        return errorStatus.length > 0;
    }

    return (
        <div className={"import-employees-container"}>
            <Flex
                className={"show-employees-container"}
                vertical={true}
                title={"Import Employees"}
            >
                <div className={"upload-file-header"}>
                    <h2 className={"page-title"}>{tempResource.mainHeading}</h2>
                    <Flex justify={"space-around"} gap={5}>
                        {/*Upload .csv file Button*/}
                        <label
                            htmlFor="upload"
                            className={"upload-file-label"}
                        >
                            <CloudUploadOutlined/>{tempResource.uploadFileButtonText}
                        </label>
                        <input
                            type="file"
                            name="upload"
                            id="upload"
                            className={"upload-file-input"}
                            onChange={readUploadFile}
                        />
                        {/*Save All Button*/}
                        <Button
                            className={"import-btn"}
                            color={'default'}
                            onClick={handleOkImportFile}
                            disabled={(!importedEmployeesRowData.length || isAnyError())}
                        >
                            {<SaveFilled color={"grey"}/>}{tempResource.saveAllButtonText}
                        </Button>
                    </Flex>
                </div>

                <Card
                    title={"Employees Preview"}
                    className={"preview-employees-card"}
                >
                    <PreviewEmployees importedEmployeesRowData={importedEmployeesRowData} errors={errors}/>
                </Card>
            </Flex>
            <Flex
                className={"errors"}
                vertical={true}
            >
                {errors.map((error: IClientError, index: number) => <React.Fragment>
                    {error.errors.length > 0 && <ul key={index} className={"errors-list"}>
                        {`Error in line ${error.line}`}
                        {error.errors.map((subError: any, index: number) => <li key={index}>{subError.message}</li>)}
                        <Divider/>
                    </ul>}
                </React.Fragment>)}
            </Flex>
        </div>)
}

export default EmployeeBatchUpload;
